import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { roleUrlSegment } from '@core/constants';

/**
 * Guard de seguridad por rol. Verifica que el rol del usuario coincida con el rol esperado
 * definido en `route.data['role']`; en caso contrario redirige al panel correspondiente al rol activo.
 */
@Injectable({ providedIn: 'root' })
export class RoleSecurityGuard implements CanActivate {
  private readonly _router = inject(Router);

  /**
   * Evalúa si el rol del usuario coincide con el rol requerido por la ruta.
   * @param route - Snapshot de la ruta a activar (debe incluir `data.role`)
   * @param state - Estado actual del router
   * @returns `true` si el rol coincide, o una `UrlTree` de redirección al panel del rol activo
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    const expectedRole = route.data['role'];
    const userRole = localStorage.getItem('role');

    if (userRole?.toLocaleLowerCase() === expectedRole) {
      return true;
    } else {
      // Puedes redirigir a una ruta específica si el rol no coincide
      const lowerUserRole = userRole?.toLocaleLowerCase();
      const urlRole = lowerUserRole ? roleUrlSegment(lowerUserRole) : lowerUserRole;
      return this._router.parseUrl(`${urlRole}`);
    }
  }
}
